<template>
  <div class="pos-layout" :class="{ 'inventory-mode': selectedNav === 'inventory' }">
    <!-- 左侧导航区 -->
    <aside class="sidebar">
      <!-- 顶部信息栏 -->
      <div class="sidebar-header">
        
        <div class="login-info">
          <div class="user-info">{{ displayName }}</div>
          <div class="shop-info">{{ shopName }}</div>
        </div>
      </div>

      <!-- 功能按钮组 -->
      <div class="nav-buttons">
        <div
          :class="['nav-item', { active: selectedNav === 'cashier' }]"
          @click="selectNav('cashier')"
        >
          <div class="nav-icon-text">¥</div>
          <span class="nav-text">收银</span>
        </div>
        <div
          :class="['nav-item', { active: selectedNav === 'orders' }]"
          @click="selectNav('orders')"
        >
          <div class="nav-icon-text">单</div>
          <span class="nav-text">收银订单</span>
        </div>
        <div
          :class="['nav-item', { active: selectedNav === 'members' }]"
          @click="selectNav('members')"
        >
          <div class="nav-icon-text">会</div>
          <span class="nav-text">会员</span>
        </div>
        <div
          :class="['nav-item', { active: selectedNav === 'inventory' }]"
          @click="selectNav('inventory')"
        >
          <div class="nav-icon-text">库</div>
          <span class="nav-text">库存查询</span>
        </div>
        
        <div class="nav-item" @click="logout">
          <div class="nav-icon-text">出</div>
          <span class="nav-text">退出</span>
        </div>
      </div>
    </aside>

    <!-- 中间商品选择区 -->
    <main class="product-selection" v-if="selectedNav === 'cashier'">
      <!-- 区域标题和搜索 -->
      <div class="section-header">
        <h2 class="section-title">选择商品</h2>
        <div class="search-bar">
          <input
            v-model="searchKeyword"
            type="text"
            placeholder="搜索商品名称或条码..."
            class="search-input"
            @keyup.enter="handleSearch"
          />
          <button class="search-button" @click="handleSearch">搜索</button>
        </div>
      </div>

      <!-- 分类标签 -->
      <div class="category-tabs">
        <div
          v-for="category in categories"
          :key="category.id"
          :class="['category-tab', { active: selectedCategory === category.id }]"
          @click="selectCategory(category.id)"
        >
          <span class="category-name">{{ category.name }}</span>
        </div>
      </div>

      <!-- 商品网格 -->
      <div class="products-grid">
        <div
          v-for="product in filteredProducts"
          :key="product.id"
          class="product-card"
          @click="addToCart(product)"
        >
          <div class="product-image">
              <img v-if="product.cover_image" :src="product.cover_image" :alt="product.name" />
          </div>
          <div class="product-info">
            <div class="product-name">{{ product.name }}</div>
            <div class="product-category">{{ product.category_name }}</div>
            <div class="product-stock">剩余库存: {{ product.stock }}</div>
            <div class="product-price">
              <span v-if="product.is_gift" class="gift-price">赠品</span>
              <span v-else>¥{{ product.price.toFixed(2) }}</span>
            </div>
          </div>
          <div class="add-button">+</div>
        </div>
      </div>

          </main>

    <!-- 库存管理组件 -->
    <InventoryView
      v-if="selectedNav === 'inventory'"
      :userInfo="userInfo"
    />

    <!-- 订单管理组件 -->
    <OrdersView
      v-if="selectedNav === 'orders'"
      :userInfo="userInfo"
    />

    <!-- 会员管理组件 -->
    <MembersView
      v-if="selectedNav === 'members'"
      :userInfo="userInfo"
    />

    <!-- 右侧结算操作区 - 只在收银模式下显示 -->
    <template v-if="selectedNav === 'cashier'">
      <aside class="checkout-panel">
        <!-- 会员入口 -->
        <div class="member-section">
          <button
            class="member-button"
            @click="openMemberSelector"
          >
            {{ selectedMember ? selectedMember.name : '+ 选择会员' }}
          </button>
        </div>

        <!-- 已选商品列表 -->
        <div class="cart-list">
          <h3 class="cart-title">已选商品</h3>
          <div class="cart-items">
            <div v-if="cartItems.length === 0" class="cart-empty">
              暂无商品
            </div>
            <div v-for="item in cartItems" :key="item.id" class="cart-item">
              <div class="cart-item-main">
                <div class="cart-item-name">{{ item.name }}</div>
              </div>
              <div class="cart-item-bottom">
                <div class="cart-item-price">¥{{ item.price.toFixed(2) }}</div>
                <div class="cart-item-quantity">
                  <button @click="decreaseQuantity(item)" class="quantity-btn">-</button>
                  <input
                    type="number"
                    v-model="item.quantity"
                    @input="validateQuantity(item)"
                    @blur="validateQuantity(item)"
                    class="quantity-input"
                    min="1"
                  />
                  <button @click="increaseQuantity(item)" class="quantity-btn">+</button>
                </div>
                <div class="cart-item-subtotal">¥{{ (item.price * item.quantity).toFixed(2) }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- 底部结算区域 -->
        <div class="checkout-bottom">
          <!-- 金额展示区 -->
          <div class="amount-display">
            <div class="total-amount">
              应收 <span class="amount">{{ totalAmount.toFixed(2) }}</span> 元
            </div>

    
            <div class="payment-details">
              <div class="payment-row">
                <div class="payment-left">
                  <span>实收：</span>
                  <span class="amount">¥{{ paidAmount.toFixed(2) }}</span>
                </div>
                <div class="payment-right">
                  <button
                    v-if="canZeroAmount"
                    class="modify-amount-btn"
                    @click="openAmountModifyDialog"
                  >
                    修改
                  </button>
                </div>
              </div>
              <div class="payment-row">
                <div class="payment-left">
                  <span>抹零：</span>
                  <span class="amount">¥{{ Math.abs(changeAmount).toFixed(2) }}</span>
                </div>
                <div class="payment-right"></div>
              </div>
            </div>
          </div>

          <!-- 结账按钮 -->
          <div class="checkout-action">
            <button class="checkout-button" @click="handleCheckout">结账</button>
          </div>
        </div>
      </aside>
    </template>

    <!-- 会员选择弹窗 -->
    <MemberSelector
      :visible="showMemberSelector"
      @close="closeMemberSelector"
      @select="handleMemberSelected"
    />

    <!-- 实收金额修改弹窗 -->
    <div v-if="showAmountModifyDialog" class="amount-modify-overlay" @click="closeAmountModifyDialog">
      <div class="amount-modify-dialog" @click.stop>
        <div class="dialog-header">
          <h3>修改实收金额</h3>
          <button class="close-btn" @click="closeAmountModifyDialog">×</button>
        </div>

        <div class="dialog-content">
          <div class="amount-input-group">
            <label>应收金额：</label>
            <span class="total-amount-display">¥{{ totalAmount.toFixed(2) }}</span>
          </div>

          <div class="amount-input-group">
            <label>实收金额：</label>
            <input
              type="number"
              v-model.number="tempPaidAmount"
              class="amount-dialog-input"
              step="0.01"
              min="0"
              placeholder="请输入实收金额"
            />
            <span class="amount-unit">元</span>
          </div>

          <!-- 抹零原因选择 - 当实收不等于应收时显示 -->
          <div v-if="tempPaidAmount !== totalAmount" class="reason-input-group">
            <label>抹零原因：</label>
            <select
              v-model="tempZeroAmountReason"
              class="reason-dialog-select"
              @change="handleTempReasonChange"
            >
              <option value="">请选择原因</option>
              <option
                v-for="reason in zeroAmountReasons"
                :key="reason.value"
                :value="reason.value"
              >
                {{ reason.label }}
              </option>
            </select>

            <!-- 自定义原因输入框 -->
            <input
              v-if="tempZeroAmountReason === 'other'"
              v-model="tempCustomZeroAmountReason"
              type="text"
              class="custom-reason-dialog-input"
              placeholder="请输入抹零原因"
            />
          </div>
        </div>

        <div class="dialog-footer">
          <button class="cancel-btn" @click="closeAmountModifyDialog">取消</button>
          <button class="confirm-btn" @click="confirmAmountModify">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InventoryView from './Inventory.vue'
import OrdersView from './Orders.vue'
import MembersView from './Members.vue'
import MemberSelector from './MemberSelector.vue'
import { cashierApi } from '../api/cashier.js'
import { orderApi } from '../api/index.js'
import toast from '../utils/toast.js'

export default {
  name: 'PosSystem',
  components: {
    InventoryView,
    OrdersView,
    MembersView,
    MemberSelector
  },
  props: {
    userInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      currentTime: '',
      selectedNav: 'cashier',
      profileInfo: null, // 存储profile接口返回的信息
      searchKeyword: '',
      selectedCategory: 0,
      heldOrders: 6,
      paidAmount: 0.00,
      scanAmount: 0.00,
      categories: [],
      products: [],
      cartItems: [],
      showMemberSelector: false,
      selectedMember: null,
      isPaidAmountManuallySet: false, // 标记实收金额是否被手动设置
      showZeroAmountReason: false, // 是否显示抹零原因选择
      zeroAmountReason: '', // 选中的抹零原因
      zeroAmountReasons: [ // 预设的抹零原因
        { value: 'packaging_damage', label: '包装破损' },
        { value: 'other', label: '其他' }
      ],
      customZeroAmountReason: '', // 自定义抹零原因

      // 实收金额修改弹窗相关
      showAmountModifyDialog: false, // 是否显示实收金额修改弹窗
      tempPaidAmount: 0, // 临时实收金额
      tempZeroAmountReason: '', // 临时抹零原因
      tempCustomZeroAmountReason: '' // 临时自定义抹零原因
    }
  },
  computed: {
    // 显示的用户名，优先使用profile接口返回的信息
    displayName() {
      if (this.profileInfo && this.profileInfo.cashier_info) {
        return this.profileInfo.cashier_info.nickname || this.profileInfo.cashier_info.username
      }
      return this.userInfo.nickname || this.userInfo.username || '收银员'
    },
    // 显示的店铺名，优先使用profile接口返回的信息
    shopName() {
      if (this.profileInfo && this.profileInfo.shop_info) {
        return this.profileInfo.shop_info.name
      }
      return this.userInfo.shopName || '店铺'
    },
    // 检查用户是否有赠品权限
    canGift() {
      if (this.profileInfo && this.profileInfo.cashier_info) {
        return this.profileInfo.cashier_info.can_gift === true
      }
      return false
    },
    // 检查用户是否有零金额收款权限
    canZeroAmount() {
      if (this.profileInfo && this.profileInfo.cashier_info) {
        return this.profileInfo.cashier_info.can_zero_amount === true
      }
      return false
    },
    totalQuantity() {
      return this.cartItems.reduce((total, item) => total + item.quantity, 0)
    },
    totalTypes() {
      return this.cartItems.length
    },
    totalAmount() {
      return this.cartItems.reduce((total, item) => total + (item.price * item.quantity), 0)
    },
    changeAmount() {
      return this.paidAmount - this.totalAmount
    },
    // 判断是否需要显示抹零原因选择
    shouldShowZeroAmountReason() {
      return this.canZeroAmount &&
             this.isPaidAmountManuallySet &&
             this.paidAmount !== this.totalAmount &&
             this.totalAmount > 0
    },
    filteredProducts() {
      let filtered = this.products

      // 按分类筛选 (API返回的分类ID，0表示全部)
      if (this.selectedCategory !== 0) {
        filtered = filtered.filter(p => p.category_id === this.selectedCategory)
      }

      // 按关键词搜索
      if (this.searchKeyword) {
        filtered = filtered.filter(p =>
          p.name.toLowerCase().includes(this.searchKeyword.toLowerCase())
        )
      }

      // 根据赠品权限过滤商品
      filtered = filtered.filter(p => {
        // 如果商品是赠品但用户没有赠品权限，则不显示
        if (p.is_gift && !this.canGift) {
          return false
        }
        return true
      })

      return filtered
    }
  },
  watch: {
    // 监听应收金额变化，自动更新实收金额
    totalAmount(newAmount) {
      // 如果购物车为空，重置标记和抹零原因
      if (newAmount === 0) {
        this.isPaidAmountManuallySet = false
        this.paidAmount = 0
        this.zeroAmountReason = ''
        this.customZeroAmountReason = ''
        return
      }

      // 只有在有零金额收款权限且用户没有手动修改过实收金额时才自动更新
      if (this.canZeroAmount && !this.isPaidAmountManuallySet) {
        this.paidAmount = newAmount
      }
    }
  },
  methods: {
    // 加载商品分类
    async loadCategories() {
      try {
        const result = await cashierApi.getShopCategories()
        if (result.success && result.data) {
          // 添加"全部"分类到最前面
          this.categories = [
            { id: 0, name: '全部', text: '全' },
            ...result.data.map(cat => ({
              id: cat.id,
              name: cat.title,
              text: cat.title.charAt(0)
            }))
          ]
          console.log('商品分类加载成功:', this.categories)
        } else {
          console.error('获取商品分类失败:', result.message)
        }
      } catch (error) {
        console.error('获取商品分类异常:', error)
      }
    },

    // 加载商品列表
    async loadProducts() {
      try {
        const result = await cashierApi.getShopProducts()
        if (result.success && result.data && result.data.list) {
          this.products = result.data.list.map(item => {
            const product = item.product
            return {
              id: product.ID,
              name: product.name,
              price: product.normal_price,
              member_price: product.member_price,
              stock: item.quantity, // 库存数量在inventory item中
              category_id: product.category_id,
              category_name: product.category ? product.category.title : '',
              cover_image: product.cover_image, // 添加商品图片
              is_gift: product.is_gift === true, // 确保is_gift是布尔值
              status: product.status,
              code: product.ID.toString(), // 临时使用ID作为条码
              text: product.name.charAt(0)
            }
          })
          console.log('商品列表加载成功:', this.products)
        } else {
          console.error('获取商品列表失败:', result.message)
        }
      } catch (error) {
        console.error('获取商品列表异常:', error)
      }
    },

    // 根据分类名称获取分类ID
    getCategoryIdByName(categoryName) {
      const category = this.categories.find(cat => cat.name === categoryName)
      return category ? category.id : 0
    },

    // 加载用户详细信息
    async loadProfileInfo() {
      try {
        const result = await cashierApi.getProfile()
        if (result.success) {
          this.profileInfo = result.data
          console.log('用户信息加载成功:', this.profileInfo)
        } else {
          console.error('获取用户信息失败:', result.message)
        }
      } catch (error) {
        console.error('获取用户信息异常:', error)
      }
    },

    updateTime() {
      const now = new Date()
      this.currentTime = now.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      }).replace(/\//g, '/')
    },

    logout() {
      if (confirm('确定要退出登录吗？')) {
        // 清除本地存储
        localStorage.removeItem('isLoggedIn')
        localStorage.removeItem('token')
        localStorage.removeItem('username')
        localStorage.removeItem('nickname')
        localStorage.removeItem('shopId')
        localStorage.removeItem('shopName')

        // 通知父组件退出登录
        this.$emit('logout')

        alert('已退出登录')
      }
    },
    selectNav(navId) {
      this.selectedNav = navId
    },
    increaseQuantity(item) {
      item.quantity++
    },
    decreaseQuantity(item) {
      if (item.quantity > 1) {
        item.quantity--
      } else {
        this.removeItem(item)
      }
    },
    removeItem(item) {
      const index = this.cartItems.indexOf(item)
      if (index > -1) {
        this.cartItems.splice(index, 1)
      }
    },

    // 新增方法
    selectCategory(categoryId) {
      this.selectedCategory = categoryId
    },

    handleSearch() {
      // 搜索结果会自动通过filteredProducts计算属性更新
      if (!this.searchKeyword.trim()) {
        alert('请输入搜索关键词')
        return
      }

      const results = this.filteredProducts
      if (results.length === 0) {
        alert('未找到匹配的商品')
      } else {
        alert(`找到 ${results.length} 个商品`)
      }
    },

    validateQuantity(item) {
      // 确保数量是有效的数字
      let quantity = parseInt(item.quantity)

      if (isNaN(quantity) || quantity < 1) {
        quantity = 1
      }

      // 如果数量变为0，移除该商品
      if (quantity === 0) {
        this.removeItem(item)
        return
      }

      item.quantity = quantity
    },

    addToCart(product) {
      const existingItem = this.cartItems.find(item => item.id === product.id)

      if (existingItem) {
        existingItem.quantity++
      } else {
        this.cartItems.push({
          id: product.id,
          name: product.name,
          code: product.code,
          price: product.price,
          memberPrice: product.member_price,
          quantity: 1
        })
      }
    },

    // 会员选择相关方法
    openMemberSelector() {
      this.showMemberSelector = true
    },

    closeMemberSelector() {
      this.showMemberSelector = false
    },

    handleMemberSelected(member) {
      this.selectedMember = member
      console.log('已选择会员:', member)
      // 这里可以添加其他处理逻辑，比如应用会员折扣等
    },

    // 处理实收金额输入
    handlePaidAmountInput() {
      this.isPaidAmountManuallySet = true
    },

    // 处理抹零原因变化
    handleReasonChange() {
      // 当选择预设原因时，清空自定义原因
      if (this.zeroAmountReason !== 'other') {
        this.customZeroAmountReason = ''
      }
    },

    // 获取最终抹零原因
    getZeroAmountReasonText() {
      if (this.zeroAmountReason === 'other') {
        return this.customZeroAmountReason
      }
      const reason = this.zeroAmountReasons.find(r => r.value === this.zeroAmountReason)
      return reason ? reason.label : ''
    },

    // 实收金额修改弹窗相关方法
    closeAmountModifyDialog() {
      this.showAmountModifyDialog = false
    },

    // 打开实收金额修改弹窗
    openAmountModifyDialog() {
      this.tempPaidAmount = this.paidAmount
      this.tempZeroAmountReason = this.zeroAmountReason
      this.tempCustomZeroAmountReason = this.customZeroAmountReason
      this.showAmountModifyDialog = true
    },

    // 处理临时抹零原因变化
    handleTempReasonChange() {
      // 当选择预设原因时，清空自定义原因
      if (this.tempZeroAmountReason !== 'other') {
        this.tempCustomZeroAmountReason = ''
      }
    },

    // 确认修改实收金额
    confirmAmountModify() {
      // 验证实收金额
      if (this.tempPaidAmount < 0) {
        toast.error('实收金额不能为负数')
        return
      }

      // 如果实收不等于应收，验证抹零原因
      if (this.tempPaidAmount !== this.totalAmount) {
        if (!this.tempZeroAmountReason) {
          toast.warning('请选择抹零原因')
          return
        }
        if (this.tempZeroAmountReason === 'other' && !this.tempCustomZeroAmountReason.trim()) {
          toast.warning('请输入自定义抹零原因')
          return
        }
      }

      // 应用修改
      this.paidAmount = this.tempPaidAmount
      this.zeroAmountReason = this.tempZeroAmountReason
      this.customZeroAmountReason = this.tempCustomZeroAmountReason
      this.isPaidAmountManuallySet = true

      // 关闭弹窗
      this.closeAmountModifyDialog()
    },

    // 处理结账
    async handleCheckout() {
      // 验证购物车
      if (this.cartItems.length === 0) {
        toast.warning('购物车为空，无法结账')
        return
      }

      // 验证实收金额
      if (this.paidAmount < 0) {
        toast.error('实收金额不能为负数')
        return
      }

      // 验证抹零原因（如果实收金额小于应收金额）
      if (this.paidAmount < this.totalAmount) {
        if (!this.zeroAmountReason) {
          toast.warning('实收金额小于应收金额，请选择抹零原因')
          return
        }
        if (this.zeroAmountReason === 'other' && !this.customZeroAmountReason.trim()) {
          toast.warning('请输入自定义抹零原因')
          return
        }
      }

      // 构建商品数据
      const items = this.cartItems.map(cartItem => ({
        product_id: cartItem.id,
        quantity: cartItem.quantity,
        price: cartItem.price
      }))

      // 验证商品数据
      for (const item of items) {
        if (!item.product_id || item.quantity <= 0 || item.price < 0) {
          toast.error('商品数据异常，请检查购物车')
          return
        }
      }

      // 构建订单数据
      const orderData = {
        items: items,
        member_id: this.selectedMember ? this.selectedMember.id : undefined,
        final_amount: this.paidAmount,
        remark: this.paidAmount < this.totalAmount ? (this.zeroAmountReason === 'other' ? this.customZeroAmountReason : this.getZeroAmountReasonText()) : undefined
      }

      // 获取结账按钮并保存原始文本
      const checkoutButton = document.querySelector('.checkout-button')
      const originalButtonText = checkoutButton?.textContent || '结账'

      try {
        console.log('提交订单数据:', orderData)

        // 显示加载状态
        if (checkoutButton) {
          checkoutButton.textContent = '提交中...'
          checkoutButton.disabled = true
        }

        const result = await orderApi.createCashierOrder(orderData)

        if (result.success && result.data) {
          toast.success(`交易完成！订单号：${result.data.order_no || 'N/A'}`)

          // 清空购物车和相关状态
          this.cartItems = []
          this.selectedMember = null
          this.paidAmount = 0.00
          this.isPaidAmountManuallySet = false
          this.zeroAmountReason = ''
          this.customZeroAmountReason = ''

          console.log('订单创建成功，订单号:', result.data.order_no)

          // 重新获取商品列表以更新库存
          this.loadProducts()
        } else {
          const errorMsg = result.message || '未知错误'
          console.error('订单创建失败:', result)
          toast.error(`交易失败：${errorMsg}`)
        }
      } catch (error) {
        console.error('订单创建异常:', error)

        // 根据错误类型显示不同提示
        let errorMessage = '订单创建异常，请稍后重试'
        if (error.message.includes('Network')) {
          errorMessage = '网络连接异常，请检查网络后重试'
        } else if (error.message.includes('timeout')) {
          errorMessage = '请求超时，请稍后重试'
        } else if (error.response) {
          errorMessage = `服务器错误：${error.response.status} ${error.response.statusText || ''}`
        }

        toast.error(errorMessage)
      } finally {
        // 恢复按钮状态
        if (checkoutButton) {
          checkoutButton.textContent = originalButtonText
          checkoutButton.disabled = false
        }
      }
    }
  },
  mounted() {
    this.updateTime()
    setInterval(this.updateTime, 60000) // 每分钟更新一次时间
    this.loadProfileInfo() // 加载用户详细信息

    // 先加载分类，再加载商品
    this.loadCategories().then(() => {
      this.loadProducts()
    })
  },
}
</script>

<style scoped>
.pos-layout {
  display: flex;
  height: 100vh;
  background-color: #f5f5f5;
  font-family: 'Microsoft YaHei', sans-serif;
}

.pos-layout.inventory-mode {
  display: flex;
}

/* 左侧导航区 */
.sidebar {
  flex: 0 0 15%; /* 固定15%宽度，不伸缩 */
  background-color: #2c3e50;
  color: white;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #34495e;
  min-width: 0; /* 防止flex子项溢出 */
}

.sidebar-header {
  padding: 20px;
  border-bottom: 1px solid #34495e;
  text-align: center;
}

.time-display {
  font-size: 14px;
  margin-bottom: 8px;
  opacity: 0.9;
}

.login-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.user-info {
  font-size: 14px;
  font-weight: 500;
  color: #ecf0f1;
  opacity: 0.9;
}

.shop-info {
  font-size: 11px;
  color: #95a5a6;
  opacity: 0.7;
}

.nav-buttons {
  flex: 1;
  padding: 20px 0;
}

.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15px 10px;
  cursor: pointer;
  transition: background-color 0.3s;
  margin: 5px 10px;
  border-radius: 6px;
}

.nav-item:hover {
  background-color: #34495e;
}

.nav-item.active {
  background-color: #1890ff;
}

.nav-icon-text {
  font-size: 20px;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
}

.nav-text {
  font-size: 12px;
}

/* 中间商品清单区 */
.product-list {
  width: 60%;
  background-color: white;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #e8e8e8;
}

.section-title {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  padding: 20px;
  border-bottom: 2px solid #f0f0f0;
  color: #2c3e50;
}

.list-header {
  display: grid;
  grid-template-columns: 3fr 1fr 1fr 1fr 1fr 1fr;
  background-color: #fafafa;
  padding: 15px;
  border-bottom: 1px solid #e8e8e8;
  font-weight: bold;
  font-size: 14px;
  color: #666;
}

.product-row {
  display: grid;
  grid-template-columns: 3fr 1fr 1fr 1fr 1fr 1fr;
  padding: 15px;
  border-bottom: 1px solid #f0f0f0;
  align-items: center;
}

.product-row:hover {
  background-color: #f9f9f9;
}

.product-name {
  font-weight: 500;
  margin-bottom: 3px;
}

.product-code {
  font-size: 12px;
  color: #999;
}

.col-price, .col-member-price, .col-subtotal {
  text-align: center;
}

.quantity-controls {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
}

.quantity {
  min-width: 30px;
  text-align: center;
  font-weight: 500;
}

.col-actions {
  text-align: center;
}

.bottom-actions {
  margin-top: auto;
  padding: 20px;
  background-color: #fafafa;
  border-top: 1px solid #e8e8e8;
  display: flex;
  align-items: center;
  gap: 20px;
}

.stats-section {
  color: #666;
  font-size: 14px;
}

.action-buttons {
  margin-left: auto;
  display: flex;
  gap: 10px;
}

/* 右侧结算操作区 */
.checkout-panel {
  flex: 0 0 25%; /* 固定25%宽度，不伸缩 */
  background-color: #fafafa;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-width: 0; /* 防止flex子项溢出 */
}

.member-section {
  padding: 10px 0;
  flex-shrink: 0;
}

.cart-list {
  background-color: white;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 400px;
}

.cart-title {
  margin: 0 0 15px 0;
  font-size: 16px;
  font-weight: bold;
  color: #333;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
  flex-shrink: 0;
}

.cart-items {
  display: flex;
  flex-direction: column;
  gap: 6px;
  overflow-y: auto;
  flex: 1;
}

.checkout-bottom {
  display: flex;
  flex-direction: column;
  gap: 15px;
  flex-shrink: 0;
}

.cart-empty {
  text-align: center;
  color: #999;
  padding: 20px 0;
  font-size: 14px;
}

.cart-item {
  padding: 12px;
  background-color: #f9f9f9;
  border-radius: 6px;
  border: 1px solid #e8e8e8;
  transition: all 0.2s;
}

.cart-item:hover {
  background-color: #f0f0f0;
  border-color: #1890ff;
}

.cart-item-main {
  margin-bottom: 8px;
}

.cart-item-name {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  line-height: 1.3;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.cart-item-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.cart-item-price {
  color: #666;
  font-size: 12px;
  min-width: 40px;
}

.cart-item-subtotal {
  color: #e74c3c;
  font-weight: 500;
  font-size: 12px;
  min-width: 50px;
  text-align: right;
}

.cart-item-quantity {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.quantity-btn {
  width: 28px;
  height: 28px;
  border: 1px solid #d9d9d9;
  background-color: white;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.quantity-btn:hover {
  background-color: #1890ff;
  color: white;
  border-color: #1890ff;
  transform: scale(1.05);
  box-shadow: 0 2px 6px rgba(24,144,255,0.3);
}

.quantity-btn:active {
  transform: scale(0.95);
}

.quantity-input {
  width: 50px;
  height: 28px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  text-align: center;
  font-weight: 600;
  font-size: 14px;
  color: #333;
  background-color: white;
  outline: none;
  transition: all 0.2s;
}

.quantity-input:focus {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24,144,255,0.2);
}

.quantity {
  min-width: 24px;
  text-align: center;
  font-weight: 600;
  font-size: 14px;
  color: #333;
}

.amount-display {
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.total-amount {
  text-align: center;
  font-size: 16px;
  margin-bottom: 20px;
  color: #333;
}

.total-amount .amount {
  font-size: 28px;
  font-weight: bold;
  color: #1890ff;
}

.actual-amount-input {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 10px 0;
  padding: 8px;
  background-color: #f9f9f9;
  border-radius: 4px;
  border: 1px solid #e8e8e8;
  width: 100%;
  box-sizing: border-box;
}

.actual-amount-input label {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  min-width: 40px;
  flex-shrink: 0;
}

.amount-input-field {
  flex: 1;
  height: 28px;
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  padding: 0 8px;
  font-size: 14px;
  font-weight: bold;
  color: #1890ff;
  background-color: white;
  outline: none;
  transition: all 0.2s;
  min-width: 0;
  box-sizing: border-box;
}

.amount-input-field:focus {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24,144,255,0.2);
}

.amount-unit {
  font-size: 14px;
  color: #666;
  min-width: 20px;
  flex-shrink: 0;
}

.zero-amount-reason {
  margin: 10px 0;
  padding: 8px;
  background-color: #fff7e6;
  border: 1px solid #ffd591;
  border-radius: 4px;
}

.reason-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.reason-label {
  font-size: 12px;
  font-weight: 500;
  color: #d46b08;
  min-width: 60px;
  flex-shrink: 0;
}

.reason-select-compact {
  flex: 1;
  min-width: 0;
  height: 28px;
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  padding: 0 6px;
  font-size: 12px;
  background-color: white;
  outline: none;
  transition: all 0.2s;
  box-sizing: border-box;
}

.reason-select-compact:focus {
  border-color: #1890ff;
  box-shadow: 0 0 0 1px rgba(24,144,255,0.2);
}

.custom-reason-input-compact {
  flex: 1;
  min-width: 0;
  height: 28px;
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  padding: 0 6px;
  font-size: 12px;
  background-color: white;
  outline: none;
  transition: all 0.2s;
  box-sizing: border-box;
}

.custom-reason-input-compact:focus {
  border-color: #1890ff;
  box-shadow: 0 0 0 1px rgba(24,144,255,0.2);
}

.payment-details {
  border-top: 1px solid #f0f0f0;
  padding-top: 10px;
}

.payment-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  font-size: 14px;
}

.payment-left {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
}

.payment-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.payment-row .amount {
  font-weight: 500;
  color: #333;
  min-width: 80px;
  text-align: right;
}

.modify-amount-btn {
  background: none;
  border: none;
  color: #1890ff;
  font-size: 12px;
  cursor: pointer;
  padding: 2px 8px;
  border-radius: 4px;
  transition: all 0.2s;
}

.modify-amount-btn:hover {
  background-color: #f0f8ff;
  color: #4096ff;
}

.checkout-action {
  margin-top: 10px;
}

.checkout-button {
  width: 100%;
  height: 50px;
  background: #1890ff;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s;
}

.checkout-button:hover {
  background: #4096ff;
}

/* 实收金额修改弹窗样式 */
.amount-modify-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.amount-modify-dialog {
  background-color: white;
  border-radius: 8px;
  width: 400px;
  max-width: 90vw;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
}

.dialog-header h3 {
  margin: 0;
  font-size: 16px;
  color: #333;
}

.close-btn {
  background: none;
  border: none;
  font-size: 20px;
  color: #999;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s;
}

.close-btn:hover {
  background-color: #f5f5f5;
  color: #666;
}

.dialog-content {
  padding: 20px;
}

.amount-input-group {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.amount-input-group label {
  min-width: 80px;
  font-size: 14px;
  color: #333;
}

.total-amount-display {
  font-size: 16px;
  font-weight: bold;
  color: #1890ff;
}

.amount-dialog-input {
  flex: 1;
  height: 36px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 0 12px;
  font-size: 14px;
  background-color: white;
  outline: none;
  transition: all 0.2s;
}

.amount-dialog-input:focus {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24,144,255,0.2);
}

.reason-input-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.reason-input-group label {
  font-size: 14px;
  color: #333;
  margin-bottom: 4px;
}

.reason-dialog-select {
  width: 100%;
  height: 32px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 0 8px;
  font-size: 14px;
  background-color: white;
  outline: none;
  transition: all 0.2s;
}

.reason-dialog-select:focus {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24,144,255,0.2);
}

.custom-reason-dialog-input {
  width: 100%;
  height: 32px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 0 8px;
  font-size: 14px;
  background-color: white;
  outline: none;
  transition: all 0.2s;
  margin-top: 8px;
}

.custom-reason-dialog-input:focus {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24,144,255,0.2);
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 20px;
  border-top: 1px solid #f0f0f0;
}

.cancel-btn {
  background-color: white;
  color: #666;
  border: 1px solid #d9d9d9;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;
}

.cancel-btn:hover {
  border-color: #4096ff;
  color: #4096ff;
}

.confirm-btn {
  background-color: #1890ff;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;
}

.confirm-btn:hover {
  background-color: #4096ff;
}

/* 商品选择区域样式 */
.product-selection {
  flex: 1;
  height: 100vh;
  background-color: white;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #e8e8e8;
  min-width: 0; /* 防止flex子项溢出 */
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #f0f0f0;
  background-color: #fafafa;
  flex-shrink: 0;
  min-height: 80px;
  position: relative;
  z-index: 10;
}

.section-title {
  margin: 0;
  font-size: 20px;
  font-weight: bold;
  color: #2c3e50;
}

.search-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  position: relative;
  z-index: 11;
}

.search-input {
  background-color: white;
  border: 1px solid #d9d9d9;
  height: 32px;
  padding: 0 12px;
  border-radius: 6px;
  font-size: 14px;
  width: 300px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  outline: none;
  transition: all 0.2s;
}

.search-input:focus {
  border-color: #1890ff;
  box-shadow: 0 2px 8px rgba(24,144,255,0.2);
}

.search-button {
  background-color: #1890ff;
  color: white;
  border: none;
  height: 32px;
  padding: 0 16px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.search-button:hover {
  background-color: #4096ff;
}

.member-button {
  width: 100%;
  background-color: #1890ff;
  color: white;
  border: none;
  height: 40px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.member-button:hover {
  background-color: #4096ff;
}

.category-tabs {
  display: flex;
  padding: 15px 20px;
  gap: 12px;
  background-color: white;
  border-bottom: 1px solid #e8e8e8;
  overflow-x: auto;
}

.category-tab {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  border: 1px solid #d9d9d9;
  border-radius: 20px;
  cursor: pointer;
  font-size: 14px;
  white-space: nowrap;
  background-color: white;
  transition: all 0.3s;
  min-width: 80px;
}

.category-tab:hover {
  border-color: #1890ff;
  color: #1890ff;
  transform: translateY(-1px);
}

.category-tab.active {
  background-color: #1890ff;
  border-color: #1890ff;
  color: white;
}

.category-name {
  font-size: 14px;
  font-weight: 500;
}

.products-grid {
  flex: 1;
  padding: 20px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 16px;
  overflow-y: auto;
  min-height: 0;
}

.product-card {
  background-color: white;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 12px;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: relative;
  height: 180px;
}

.product-card:hover {
  border-color: #1890ff;
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.15);
  transform: translateY(-2px);
}

.product-image {
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  background-color: #f5f5f5;
  border-radius: 8px;
  overflow: hidden;
}

.product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-info {
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.product-name {
  font-size: 12px;
  font-weight: 500;
  color: #2c3e50;
  line-height: 1.2;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.product-stock {
  font-size: 10px;
  color: #666;
  margin-bottom: 4px;
}

.product-category {
  display: inline-block;
  background-color: #e8f4fd;
  color: #1890ff;
  font-size: 10px;
  padding: 1px 5px;
  border-radius: 2px;
  margin-bottom: 4px;
  max-width: fit-content;
}

.product-price {
  font-size: 16px;
  font-weight: bold;
  color: #e74c3c;
}

.gift-price {
  color: #52c41a;
  font-size: 12px;
}

.add-button {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 24px;
  height: 24px;
  background-color: #1890ff;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
  opacity: 0;
  transform: scale(0.8);
  transition: all 0.3s;
}

.product-card:hover .add-button {
  opacity: 1;
  transform: scale(1);
}



/* 修改中间区域的宽度适配 */
.pos-layout {
  display: flex;
  height: 100vh;
  background-color: #f5f5f5;
  font-family: 'Microsoft YaHei', sans-serif;
}
</style>